import React from "react";
import { customStyles as customStyles2 } from "./customStyles";
import Select, { components, createFilter } from "react-select";
import { CustomOption } from "@components/SelectCustomStyles";
import ToolTip from "@components/Tooltip";

const SelectWrapper = ({
  divclassname,
  className,
  options,
  onChange,
  error,
  labelClassName,
  name,
  styles,
  label,
  value,
  toolTipContent,
  subLabel,
  isNotFlex,
  borderRadius = 9999,
  placeholder = "",
  customStyles = customStyles2,
  customDesign,
  ...restProps
}) => {
  return (
    <div
      className={`${!isNotFlex ? "flex flex-col" : ""} ${
        divclassname ?? "w-full md:w-1/2 mb-4"
      }`}
    >
      {label && (
        <>
          {toolTipContent ? (
            <div className='flex items-center gap-1'>
              <label
                htmlFor={name}
                className={`${
                  labelClassName
                    ? labelClassName
                    : "font-medium text-xs text-gray-700"
                }`}
              >
                {label}
              </label>
              {subLabel && subLabel}
              <ToolTip toolTipContent={toolTipContent} />
            </div>
          ) : (
            <label
              htmlFor={name}
              className={`${
                labelClassName
                  ? labelClassName
                  : "font-medium text-xs text-gray-700"
              }`}
            >
              {label}
              {subLabel && subLabel}
            </label>
          )}
        </>
      )}
      <Select
        isSearchable
        options={options ?? []}
        onChange={onChange}
        name={name}
        id={name}
        placeholder={placeholder || ""}
        className={className}
        styles={
          customDesign === "grayDropdown"
            ? {
                control: (base, state) => ({
                  ...base,
                  backgroundColor: "#525252",
                  borderColor: state.isFocused ? "#888" : "#D9D9D9",
                  boxShadow: "none",
                  height: 38,
                  minHeight: 38,
                  borderRadius: borderRadius,
                  padding: 0,
                  alignItems: "center",
                  cursor: "pointer",
                }),

                indicatorsContainer: (base) => ({
                  ...base,
                  height: 38,
                  display: "flex",
                  alignItems: "center",
                }),

                singleValue: (base) => ({
                  ...base,
                  fontSize: 14,
                  color: "#fff",
                  height: "38px",
                  lineHeight: "32px",
                }),
                placeholder: (base) => ({
                  ...base,
                  fontSize: 14,
                  color: "#fff",
                  // marginTop: -10,
                  // opacity: 0,
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: "#fff",
                  padding: 0,
                  marginRight: 6,
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }),
                indicatorSeparator: () => ({
                  display: "none",
                }),
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: 200,
                  overflowY: "auto",
                }),
                option: (base, state) => ({
                  ...base,
                  backgroundColor: state.isSelected
                    ? "#000"
                    : state.isFocused
                    ? "#E5E5E5"
                    : "#fff",
                  color: state.isSelected ? "#fff" : "#000",
                  fontSize: 14,
                  // paddingTop: 8,
                  // paddingBottom: 8,
                  cursor: "pointer",
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                  maxHeight: 200,
                  overflowY: "auto",
                }),
              }
            : styles ?? customStyles(error)
        }
        value={value}
        {...restProps}
      />

      {error && <div className='text-xs text-danger mt-1'>{error}</div>}
    </div>
  );
};

export default SelectWrapper;

export const VirtualizedSelect = ({
  divclassname,
  className,
  options,
  onChange,
  error,
  labelClassName,
  name,
  styles,
  label,
  value,
  ...restProps
}) => {
  const customFilter = createFilter({ ignoreAccents: false });
  const customComponents = {
    Option: CustomOption,
  };

  return (
    <div className={`flex flex-col ${divclassname ?? ""}`}>
      {label && (
        <label
          htmlFor={name}
          className={`${
            labelClassName ? labelClassName : "font-semibold text-sm"
          }`}
        >
          {label}
        </label>
      )}
      <Select
        maxMenuHeight={200}
        components={customComponents}
        filterOption={customFilter}
        options={options}
        value={value}
        onChange={onChange}
        styles={{
          // please do not add menulist styles this will break the component
          option: (provided, state) => ({
            ...provided,
            background:
              state.isFocused || state.isSelected ? "#5897FB" : "white",
            color: state.isFocused || state.isSelected ? "white" : "black",
            fontweight: "normal",
            display: "block",
            whitespace: "pre",
            fontSize: "12px",
            height: 22,
          }),
          menu: (provided) => ({
            ...provided,
            margin: 0,
            zIndex: 999,
          }),
          placeholder: (provided) => ({
            ...provided,
            color: "#8e8e8e",
            fontSize: "12px",
          }),
          control: (base, state) => ({
            display: "flex",
            justifyContent: "space-between",
            border: state.isFocused ? "1px solid #00A6E9" : "1px solid #dfdfdf",
            borderRadius: "4px",
            background: "#FFFFFF",
            height: 40,
          }),
          indicatorSeparator: () => ({
            background: "transparent",
          }),
          container: (provided) => ({
            ...provided,
            width: "100%",
          }),
        }}
        {...restProps}
      />
      {error && <div className='text-xs text-danger'>{error}</div>}
    </div>
  );
};
